<template>
<div class="col-md-12 col-12 m-0 p-0">
  <div class="col-md-12 sikander m-auto p-0">
    <div class="col-md-12 col-12 m-0 p-0" style="background:#F8F8F8">
      <div class="row col-md-9  p-0 m-auto   py-5" >
      
      <div class="col-md-4 col-12" style="justify-content:left">
        <h1 class="cal text-left">Experience the mobile app</h1>
          <div class="col-md-12 d-flex m-0 p-0" style="justify-content:left">
            <img
              alt="pitstop playstore"
              src="https://cube.getpitstop.com/assets/img/playstore.png"
               width="auto" height="50px"
            />
            <img class="mt-1 pl-1" src="https://on-track.in/wp-content/uploads/2020/10/appstore_3x_986b88218b6de481d2ddb4b9087c8ee5.png" alt="" width="auto" height="40px">
          </div>
      </div>
      <div class="col-md-4 col-12 text-left">
        <h1 class="cal">BUY SAFE, PAY EASY</h1>
         <p class="dfh" style="font-size:14px; font-weight:500; letter-spacing:0.5px; color:#999999"><span><i class="fa fa-calendar" aria-hidden="true"></i></span> Credit card EMI : Now pay in easy installments </p>
      </div>
      <div class="col-md-4 col-12" style="justify-content:center">
        <h1 class="cal">FOLLOW US</h1>
            <a href="https://www.facebook.com/ontrackBikes/">  <img src="https://cdn1.iconfinder.com/data/icons/social-media-2285/512/Colored_Facebook3_svg-128.png" alt="" width="auto" height="30px" class="pr-2"></a>
            <a  href="https://www.linkedin.com/company/ontrack-technologies-private-limited/">  <img src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Linkedin_unofficial_colored_svg-128.png" alt="" width="auto" height="30px" class="pr-2"></a>
            <a href="https://www.instagram.com/ontrackbikes/">  <img src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-128.png" alt=" "  width="auto" height="30px" class="pr-2"></a>
              
      </div>
    </div>
    </div>
        <div class="col-md-9 d-flex py-3 call  border1 m-auto" style="justify-content:space-between ">
            <a href="https://on-track.in/about/">   <p >About Us</p></a>
            <a href="https://on-track.in/blog-2/">  <p>Blog</p></a>
            <p @click="$router.push('/termsandcondition')" style="cursor:pointer">Terms & Conditions</p>
            <a href="https://on-track.in/privacy-policy2/">  <p>Privacy Policy</p></a>
            <a href="mailto:info@on-track.in"><p>Contact Us</p></a>
            <a href="mailto:info@on-track.in"><p>Partner With Us</p></a>
        </div>
    <hr class="my-0 py-0">
    <div class="col-md-12 pt-2 m-0 p-0" style=" background: #4E44D8; color:white">
        <div class="col-md-9 mr-0 pr-0  d-flex py-2  border1 m-auto" style="justify-content:space-between;">
        <div class="col-md-6 m-0 p-0 text-left">
            <img src="https://on-track.in/wp-content/uploads/2020/10/logo-white.svg" alt="" width="120px" height="60px">
            <p style="font-size:12px">We are here to make your everyday travel hassle-free! We offer a wide range of two-wheelers with easy purchase options. Now your day-to-day travel can be high on affordability and extremely efficient.</p>
            
        </div>
        <div class="col-md-6 m-0  p-0">
            <p class="text-right" style="font-weight:bolder;cursor:pointer;padding-top:50px" @click="scrollToTop"><i class="fa fa-arrow-up pr-2" style="color:white" aria-hidden="true"></i> BACK TO TOP</p>
            <p class="text-right pt-2" >© 2020 - Ontrack Technologies Pvt Ltd. - All rights reserved</p>
        </div>
    </div>
    </div>
  </div>
  <div>
  </div>



    <div class="col-12 poui m-0 p-0">
      <div class="col-md-12 col-12 m-0 p-0" style="background:#F8F8F8">
        <div class="row col-md-9 pl-3  p-0 m-auto   py-5" >
          <!-- <div class=" col-12 mb-4 text-left" style="">
            <h1 class="cal">FOLLOW US</h1>
                <a href="https://www.facebook.com/ontrackBikes/">  <img src="https://cdn1.iconfinder.com/data/icons/social-media-2285/512/Colored_Facebook3_svg-128.png" alt="" width="auto" height="30px" class="pr-2"></a>
                <a  href="https://www.linkedin.com/company/ontrack-technologies-private-limited/">  <img src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Linkedin_unofficial_colored_svg-128.png" alt="" width="auto" height="30px" class="pr-2"></a>
                <a href="https://www.instagram.com/ontrackbikes/">  <img src="https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-128.png" alt=" "  width="auto" height="30px" class="pr-2"></a>    
          </div> -->
          <div class=" col-12 mb-4" style="cursor:pointer">
            <h1 class="cal text-left">Experience the mobile app</h1>
              <div class="col-md-12 d-flex m-0 p-0" style="justify-content:left;cursor:pointer">
               <a href="https://play.google.com/store/apps/details?id=com.ontrack.ontrack" target="_blank"> <img style="cursor:pointer"
                  alt="pitstop playstore"
                  src="https://cube.getpitstop.com/assets/img/playstore.png"
                  width="auto" height="50px"
                /></a>
              <a href="https://itunes.apple.com/in/app/ontrack-monthly-bike-rental/id1433908606"><img class="mt-1 pl-1" src="https://on-track.in/wp-content/uploads/2020/10/appstore_3x_986b88218b6de481d2ddb4b9087c8ee5.png" alt="" width="auto" height="40px"></a>
              </div>
          </div>
          <div class=" col-12  text-left">
            <h1 class="cal">BUY SAFE, PAY EASY</h1>
            <p class="dfh" style="font-size:14px; font-weight:500; letter-spacing:0.5px; color:#999999"><span><i class="fa fa-calendar" aria-hidden="true"></i></span> Credit card EMI : Now pay in easy installments </p>
          </div>
          
        </div>
      </div>
      <div class="row col-12 py-3 m-0 p-0 px-3 " style=" background: #4E44D8; color:white; cursor:pointer">
        <div class="col-6 mb-3 text-left">
          <a href="https://on-track.in/about/"> <p >About Us</p></a>
        </div>
        <div class="col-6  mb-3 text-left">
          <a href="mailto:info@on-track.in"><p>Contact Us</p></a>
        </div>
       
        <div class="col-6  mb-3 text-left">
           <a href="https://on-track.in/blog-2/">  <p>Blog</p></a>
        </div>
        <div class="col-6  mb-3 text-left">
          <a href="https://on-track.in/privacy-policy2/">  <p>Privacy Policy</p></a>
        </div>
         <div class="col-6  mb-3 mr-0 pr-0 text-left" >
          <p @click="$router.push('/termsandcondition')">Terms & Conditions</p>
        </div>
        <div class="col-6  mb-3 text-left">
         <a href="mailto:info@on-track.in"> <p>Partner With Us</p></a>
        </div>
        <hr style="color:white">
        <div class="col-12 my-3">
           <p class="text-center" style="font-size:12px">© 2020 - Ontrack technologies Pvt Ltd. - All rights reserved</p>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
export default {
   methods: { 
           scrollToTop() {
                window.scrollTo(0,0);
           }
        }
};
</script>

<style scoped>
.cal{
      font-size: 19px;
    font-weight: 700;
    text-transform: uppercase;
}
.poui{
    display:none;
  }
.call{
      font-size: 15px;
    font-weight: 700;
}
a{
  color:black !important;
  text-decoration: none;
}
/* .border1{
    border-bottom: 2px solid black;
} */
p{
    margin-bottom:0
}
@media only screen and (max-width: 600px) {

  .sikander{
    display:none
  }
  a{
  color:white !important;
  text-decoration: none;
}
.poui{
    display:block !important;
  }
@media only screen and (max-device-width: 768px) {
  .poui{
    display:none;
  }
} /* applied to lg also */
}
</style>